// Internal imports (Redux slice)
import {
  fetchContractDetailsFailure,
  fetchContractDetailsStart,
  fetchContractDetailsSuccess,
} from './contractDetailSlice';

// External imports (Libraries)
import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put, call, PutEffect, CallEffect } from 'redux-saga/effects';

// API services
import { ContractDetailService } from '@/api/services/contractDetailService';
import { CustomerByContractRequest } from '@/api/models/BaseRequest';
import { ContractDetails } from '@/utils/types/contractDetails';

/**
 * Saga to fetch contract details from the API.
 * @param action - Payload containing contract ID.
 */
function* fetchContractDetailSaga(
  action: PayloadAction<CustomerByContractRequest>,
): Generator<CallEffect<ContractDetails> | PutEffect, void, ContractDetails> {
  try {
    const contractDetails: ContractDetails = yield call(
      ContractDetailService.fetchContractDetails,
      action.payload,
    );
    yield put(fetchContractDetailsSuccess(contractDetails));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching Contracts failed';
    yield put(fetchContractDetailsFailure(errorMessage));
  }
}

// Watcher saga
export function* watchContractDetails() {
  yield takeLatest(fetchContractDetailsStart.type, fetchContractDetailSaga);
}
